import { FaVideo } from "react-icons/fa";

const VideoStreamingChannelCard = ({ channelName, channelState, index }) => {
  return (
    <div className="white-card w-100 shadow" key={index}>
      <div className="text-center mg-bottom-10">
        <div className="d-inline-block rounded-circle bg-navyBlue white padding-20">
          <FaVideo className="fs-30" />
        </div>
      </div>
      <h3 className="semi-bold fs-20 text-center">{channelName}</h3>
      <div className="d-flex-center mg-top-20 gap-20">
        <button
          type="button"
          class={`btn ${
            channelState === "running"
              ? "btn-success semi-bold"
              : "btn-warning text-dark semi-bold"
          }`}
          disabled={true}
        >
          {channelState === "running" ? "Running" : "Stopped"}
        </button>
      </div>
    </div>
  );
};

export default VideoStreamingChannelCard;
